module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon10.02681d3c.png";